import {useEffect, useState} from 'react';
import uuidv4 from 'uuid/v4';
import {useWebSocket} from '../../context/WebSocketProvider';
import {useSelector} from 'react-redux';
import {user} from '../../store/reducers/user';

export default function useLockPatient(patientId) {
    const [isPatientLock, setIsPatientLock] = useState(false);
    const [isLockByMe, setIsLockByMe] = useState(false);

    const uniqueId = '' + uuidv4();
    const userObject = useSelector(user);

    const {sendMessage, message} = useWebSocket();

    useEffect(() => {
        if (patientId) {
            const data = {
                lock_action: 'lock',
                lock_id: `patients_lock_${patientId}`,
            };
            sendMessage(data, 'lock_svc', uniqueId);
            const intervalId = setInterval(() => sendMessage(data, 'lock_svc', uniqueId), 1000);

            return () => {
                clearInterval(intervalId);
                const data = {
                    lock_action: 'unlock',
                    lock_id: `patients_lock_${patientId}`,
                };
                sendMessage(data, 'lock_svc', uniqueId);
            };
        }
    }, [patientId]);

    useEffect(() => {
        if (message) {
            const {success, lock_user} = message.data;
            if (lock_user) {
                setIsPatientLock(true);
                setIsLockByMe(success || userObject?.userName === lock_user);
            }
        }
    }, [message]);

    return [isPatientLock, isLockByMe];
}